import React, { useImperativeHandle, useRef, useState } from "react";
import { isEqual, isFunction } from "@Util/utils";
import ReviewTriplicateAllowanceCertificateDialog from "@Local/Finance/Components/ReviewTriplicateAllowanceCertificateDialog";

/** 折讓證明審核彈窗的 openDialog 識別值 */
const REVIEW_TRIPLICATE_ALLOWANCE_CERTIFICATE_DIALOG = "review_triplicate_allowance_certificate_dialog";

const defaultOpenDialog = "";

/**
 * 財務作業彈窗集中管理（imperative ref）
 *
 * 掛載於 TriplicateInvoiceAllowanceOverviewPage，由列表 OverflowMenu 經 openReviewCertificate 開啟。
 * 新增彈窗時：補常數、ref 暫存、useImperativeHandle 方法，並在下方 render 對應子元件。
 */
const FinanceDialogBox = React.forwardRef((props, ref) => {
	const [openDialog, setOpenDialog] = useState(defaultOpenDialog);
	/** 目前列資料（confirmPath、orderID、orderReturnID 等） */
	const sourceDataRef = useRef({});
	/** 核准成功後回呼，通常為總覽頁 refreshList */
	const refreshRef = useRef(null);

	const doRefresh = () => {
		if (isFunction(refreshRef.current)) return refreshRef.current();
	};

	const handleCloseDialog = () => {
		setOpenDialog("");
		sourceDataRef.current = {};
		// refreshRef 保留至下次 open，讓核准後 onClose → refresh 仍可執行
	};

	useImperativeHandle(
		ref,
		() => ({
			/** @param {Object} targetData 列表列資料 @param {Function} _refreshFn 核准成功後重打列表 */
			openReviewTriplicateAllowanceCertificateDialog: (targetData = {}, _refreshFn = () => {}) => {
				sourceDataRef.current = targetData;
				refreshRef.current = _refreshFn;
				setOpenDialog(REVIEW_TRIPLICATE_ALLOWANCE_CERTIFICATE_DIALOG);
			},
			closeDialog: () => handleCloseDialog(),
		}),
		// eslint-disable-next-line
		[],
	);

	return (
		<>
			<ReviewTriplicateAllowanceCertificateDialog
				open={isEqual(openDialog, REVIEW_TRIPLICATE_ALLOWANCE_CERTIFICATE_DIALOG)}
				sourceData={sourceDataRef.current}
				onClose={handleCloseDialog}
				refresh={doRefresh}
			/>
		</>
	);
});

export default FinanceDialogBox;
